import { FolderIcon, DocumentTextIcon, ArrowUturnLeftIcon } from "@heroicons/react/24/outline";
import FileActions from "./FileActions";

export default function FileList({ files, setCurrentPath, fetchFiles }) {
  // 🔙 Calculer le chemin du dossier parent
  const goUp = () => {
    setCurrentPath((prevPath) => {
      if (prevPath === "/home/nanthiat") return prevPath;
      
      const parts = prevPath.split("/").filter(Boolean);
      const newPath = "/" + parts.slice(0, -1).join("/");
      fetchFiles(newPath || "/");
      return newPath || "/";
    });
  };

  return (
    <div className="mt-2 max-h-[60vh] overflow-y-auto bg-white shadow-sm rounded-lg border border-gray-200">
      <table className="w-full table-auto text-sm">
        {/* 🔹 En-tête */}
        <thead className="bg-gray-50 text-gray-600 uppercase text-xs tracking-wide border-b">
          <tr>
            <th className="p-3 text-left">Nom</th>
            <th className="p-3 text-center w-32">Actions</th>
          </tr>
        </thead>

        {/* 🔹 Contenu */}
        <tbody className="divide-y divide-gray-200">
          {/* 🔙 Bouton remonter d’un dossier */}
          <tr className="hover:bg-gray-100 transition">
            <td className="p-2 flex items-center space-x-2">
              <ArrowUturnLeftIcon className="w-5 h-5 text-gray-500" />
              <button onClick={goUp} className="text-sm hover:underline text-gray-700">
                .. Remonter
              </button>
            </td>
            <td></td>
          </tr>

          {/* 🔁 Liste des fichiers */}
          {files.map((file, index) => (
            <tr key={index} className="hover:bg-gray-100 transition">
              <td className="p-2 flex items-center space-x-2">
                {file.type === "directory" ? (
                  <FolderIcon className="w-5 h-5 text-yellow-500" />
                ) : (
                  <DocumentTextIcon className="w-5 h-5 text-gray-500" />
                )}

                <button
                  onClick={() => {
                    if (file.type === "directory") {
                      setCurrentPath(file.path);
                      fetchFiles(file.path);
                    }
                  }}
                  className="truncate hover:underline"
                >
                  {file.name}
                </button>
              </td>

              <td className="p-2 text-center">
                <div className="flex justify-center items-center space-x-2">
                  <FileActions file={file} fetchFiles={fetchFiles} />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
